module.exports = __webpack_public_path__ + "img/login-bg.204678fa.png";